<div class="modal-content">
  <div class="modal-header">
    <h5 class="modal-title">
      {{ 'shared.modals.preorder-detail.title' | translate }}
    </h5>
  </div>
  <div class="modal-body" *ngIf="preorders">
    <table class="detail-table">
      <tr *ngIf="preorders.reference" class="key">
        <td class="key">{{ 'shared.modals.preorder-detail.table.reference' | translate }}</td>
        <td>{{ preorders.reference }}</td>
      </tr>
      <tr *ngIf="preorders.status" class="key">
        <td class="key">{{ 'shared.modals.preorder-detail.table.status' | translate }}</td>
        <td>{{ preorders.status }}</td>
      </tr>
      <tr *ngIf="preorders.error" class="key">
        <td class="key">{{ 'shared.modals.preorder-detail.table.error' | translate }}</td>
        <td>{{ preorders.error }}</td>
      </tr>
      <tr *ngIf="preorders.created" class="key">
        <td class="key">{{ 'shared.modals.preorder-detail.table.created' | translate }}</td>
        <td>{{ preorders.created | date:'dd.MM.yyyy, HH:mm:ss' }}</td>
      </tr>
      <tr *ngIf="preorders.updated" class="key">
        <td class="key">{{ 'shared.modals.preorder-detail.table.updated' | translate }}</td>
        <td>{{ preorders.updated | date:'dd.MM.yyyy, HH:mm:ss' }}</td>
      </tr>

      <tr>
        <td colspan="2">
          <hr>
        </td>
      </tr>

      <tr *ngIf="preorders.eventDescription" class="key">
        <td class="key">{{ 'shared.modals.preorder-detail.table.event' | translate }}</td>
        <td>
          <span>
            {{ preorders.eventId }}
          </span>
          <span *ngIf="preorders.eventDescription">
            ({{ preorders.eventDescription }})
          </span>
        </td>
      </tr>
      <tr *ngIf="preorders.pointOfSaleId" class="key">
        <td class="key">{{ 'shared.modals.preorder-detail.table.pointOfSale' | translate }}</td>
        <td>
          <span>
            {{ preorders.pointOfSaleId }}
          </span>
          <span *ngIf="preorders.pointOfSaleDescription">
            ({{ preorders.pointOfSaleDescription }})
          </span>
        </td>
      </tr>
      <tr *ngIf="preorders.identificationNumber" class="key">
        <td class="key">{{ 'shared.modals.preorder-detail.table.identificationNumber' | translate }}</td>
        <td>{{ preorders.identificationNumber }}</td>
      </tr>
      <tr *ngIf="preorders.seat" class="key">
        <td class="key">{{ 'shared.modals.preorder-detail.table.seat' | translate }}</td>
        <td>{{ preorders.seat }}</td>
      </tr>
      <tr *ngIf="preorders.token" class="key">
        <td class="key">{{ 'shared.modals.preorder-detail.table.token' | translate }}</td>
        <td>{{ preorders.token }}</td>
      </tr>
      <tr>
        <td colspan="2" class="right message">
          <button class="btn btn-primary" (click)="toggleMessages()" [disabled]="!messages || messages.length === 0">
            <span *ngIf="!showMessages">{{ 'shared.modals.payment-detail.buttons.show-message' | translate }}</span>
            <span *ngIf="!!showMessages">{{ 'shared.modals.payment-detail.buttons.hide-message' | translate }}</span>
          </button>
        </td>
      </tr>
      <ng-container *ngIf="showMessages">
        <tr *ngFor="let m of messages">
          <td class="key message">{{ m.date | date:'dd.MM.yyyy, HH:mm:ss' }}</td>
          <td class="message">
            {{ m.message | json }}
          </td>
        </tr>
      </ng-container>
      <tr>
        <td colspan="2">
          <hr>
        </td>
      </tr>
    </table>
    <ng-container *ngIf="preorderProducts as products">
      <table class="detail-table">
        <thead>
        <tr>
          <th>{{ 'shared.modals.preorder-detail.table.count' | translate }}</th>
          <th>{{ 'shared.modals.preorder-detail.table.articleId' | translate }}</th>
          <th>{{ 'shared.modals.preorder-detail.table.description' | translate }}</th>
          <th>{{ 'shared.modals.preorder-detail.table.priceSingle' | translate }}</th>
          <th>{{ 'shared.modals.preorder-detail.table.priceTotal' | translate }}</th>
          <th>{{ 'shared.modals.preorder-detail.table.id' | translate }}</th>
        </tr>
        </thead>
        <tbody>
        <tr *ngFor="let p of products.products" class="key">
          <td class="key">{{ p.count }}x</td>
          <td class="key">{{ p.articleId }}</td>
          <td class="key">{{ p.description }}</td>
          <td class="key">{{ p.priceSingle / 100 | currency:products.currency }}</td>
          <td class="key">{{ p.priceTotal / 100 | currency:products.currency }}</td>
          <td class="key">{{ p.id }}</td>
        </tr>
        </tbody>
      </table>
      <div class="total">
        <strong>
          {{ 'shared.modals.preorder-detail.table.total' | translate }}
          : {{ products.amount / 100 | currency:products.currency }}
        </strong>
      </div>
    </ng-container>
  </div>
  <div class="modal-footer">
    <button class="btn btn-primary" type="button" [disabled]="!preorders || !preorders.payment"
            (click)="onShowPayment()">
      {{ 'shared.modals.preorder-detail.buttons.payment' | translate }}
    </button>
    <button class="btn btn-primary" ngbAutofocus type="button" (click)="onCloseModal()">
      {{ 'shared.modals.preorder-detail.buttons.close' | translate }}
    </button>
  </div>
</div>
